import React from 'react';
import { Link } from "react-router-dom";

import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

import FundraisingHeader from "../layout/header";
import FundraisingFooter from '../layout/footer';

const CampaignUpdates = () => {
    // Dummy data for the news grid
    const newsUpdates = [
        {
            date: 'Oct 15, 2025',
            category: 'Announcement',
            title: 'Launching the New Inclusive Play Space',
            excerpt: 'We are thrilled to announce the groundbreaking of our new sensory-friendly playground, designed for children of all abilities to explore and play.',
            image: '/assets/images/fundraising/Cozy Laptop Workspace with Notebook.png'
        },
        {
            date: 'Oct 02, 2025',
            category: 'Event',
            title: 'Annual Community Fundraising Gala',
            excerpt: 'Join us for an evening of inspiration and giving as we celebrate our progress and raise funds for the upcoming educational wing.',
            image: '/assets/images/fundraising/Engaging Corporate Presentation Scene.png'
        },
        {
            date: 'Sep 20, 2025',
            category: 'Milestone',
            title: 'Reaching 1,000 Families Served',
            excerpt: 'Thanks to our incredible partners and donors, we have officially provided resources and support to over 1,000 local families this year.',
            image: '/assets/images/fundraising/Jonesboro-Grant County Community Center.png'
        }
    ];

    return (
        <>
            <FundraisingHeader />
            <main className="overflow-hidden">

                {/* ================= HERO SECTION (Editorial Split) ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row align-items-center g-5">

                            {/* Left Column (Text) */}
                            <div className="col-lg-6 order-2 order-lg-1">
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                    style={{ background: 'rgba(251,191,36,0.12)', color: '#b45309', padding: '0.4rem 0.9rem', fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                >
                                    <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#f59e0b' }}></span>
                                    Latest News & Announcements
                                </span>

                                <h1
                                    className="fw-bold mb-4"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2.5rem, 4vw, 3.5rem)', lineHeight: 1.15, color: '#0f172a' }}
                                >
                                    Stay Connected With Our <span style={{ color: '#d97706' }}>Latest Updates.</span>
                                </h1>

                                <p className="lh-lg mb-4" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    Stay informed about our latest campaigns, ongoing initiatives, upcoming events, and community activities. We share regular updates to keep you connected with our progress and the work we're doing to create a positive impact.
                                </p>

                                <p className="lh-lg mb-4" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    Every campaign represents an opportunity to bring people together, raise awareness, and create meaningful change. Our updates highlight the progress we make and the people who help make our mission possible.
                                </p>

                                <div className="d-flex gap-3 mt-5">
                                    <Link to="#news-grid" className="text-decoration-none">
                                        <button
                                            className="btn fw-semibold rounded-pill border-0 px-4 py-3"
                                            style={{ background: '#1e293b', color: '#ffffff', boxShadow: '0 10px 25px -5px rgba(30,41,59,0.3)', transition: 'transform 0.2s ease' }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                                        >
                                            Read Latest News
                                        </button>
                                    </Link>
                                </div>
                            </div>

                            {/* Right Column (Perfect Circular Image) */}
                            <div className="col-lg-6 order-1 order-lg-2">
                                <div
                                    className="position-relative mx-auto"
                                    style={{
                                        width: '100%',
                                        maxWidth: '450px',
                                        aspectRatio: '1 / 1',
                                    }}
                                >
                                    {/* Amber Circular Backdrop */}
                                    <div
                                        className="position-absolute rounded-circle"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            background: '#1e293b',
                                            transform: 'scale(1.04)',
                                            zIndex: 0,
                                        }}
                                    />

                                    {/* Perfect Circular Image */}
                                    <img
                                        src="/assets/images/fundraising/01_capital_campaign_background.jpg"
                                        alt="Campaign Updates"
                                        className="position-relative w-100 h-100 shadow-lg"
                                        style={{
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            objectPosition: 'center',
                                            zIndex: 1,
                                            display: 'block',
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* ================= NEWS GRID SECTION ================= */}
                <section className="py-5" id="news-grid" style={{ background: '#ffffff', paddingTop: '5rem', paddingBottom: '6rem' }}>
                    <div className="container">

                        {/* Section Header */}
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-5">
                            <div>
                                <h2
                                    className="fw-bold mb-2"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3vw, 2.5rem)', color: '#0f172a' }}
                                >
                                    Recent <span style={{ color: '#d97706' }}>Highlights</span>
                                </h2>
                                <p className="mb-0" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    What you'll find here: Announcements, project updates, events, and community stories.
                                </p>
                            </div>
                            <Link to="/campaign-contact" className="text-decoration-none mt-3 mt-md-0">
                                <span className="fw-bold" style={{ color: '#1e293b' }}>
                                    View All News <span className="ms-1">→</span>
                                </span>
                            </Link>
                        </div>

                        {/* Grid of Cards */}
                        <div className="row g-4">
                            {newsUpdates.map((news, idx) => (
                                <div className="col-lg-4 col-md-6" key={idx}>
                                    <div
                                        className="card h-100 border-0 rounded-4 shadow-sm overflow-hidden"
                                        style={{ transition: 'transform 0.3s ease, box-shadow 0.3s ease', background: '#fdfaf4' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 20px 40px -15px rgba(15,23,42,0.15)'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 10px -5px rgba(15,23,42,0.05)'; }}
                                    >
                                        {/* Image */}
                                        <div className="position-relative" style={{ height: '300px' }}>
                                            <img
                                                src={news.image}
                                                alt={news.title}
                                                className="w-100 h-100 object-fit-cover"
                                            />
                                            {/* Category Badge */}
                                            <span
                                                className="position-absolute top-0 start-0 m-3 badge rounded-pill px-3 py-2"
                                                style={{ background: '#fbbf24', color: '#1e293b', fontWeight: 600 }}
                                            >
                                                {news.category}
                                            </span>
                                        </div>

                                        {/* Content */}
                                        <div className="card-body p-4 d-flex flex-column">
                                            <p className="small text-muted fw-semibold mb-2">{news.date}</p>
                                            <h4 className="fw-bold mb-3" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', fontSize: '1.25rem' }}>
                                                {news.title}
                                            </h4>
                                            <p className="lh-lg mb-4" style={{ color: '#4b5563', fontSize: '0.95rem' }}>
                                                {news.excerpt}
                                            </p>

                                            <Link to="/campaign-contact" className="text-decoration-none mt-auto">
                                                <span className="fw-bold" style={{ color: '#d97706', fontSize: '0.95rem' }}>
                                                    Read More →
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </section>

                {/* ================= OUR PROGRESS & IMPACT (Dark Strip) ================= */}
                <section className="py-5" style={{ background: '#1e293b', paddingTop: '5rem', paddingBottom: '5rem' }}>
                    <div className="container text-center">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-4"
                                    style={{ background: 'rgba(251,191,36,0.15)', color: '#fcd34d', padding: '0.4rem 1rem', fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                >
                                    Our Progress & Impact
                                </span>
                                <h2
                                    className="fw-bold mb-4 text-white"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3.5vw, 2.75rem)', lineHeight: 1.15 }}
                                >
                                    Every step forward brings us <span style={{ color: '#fbbf24' }}>closer to our goals.</span>
                                </h2>
                                <p className="lh-lg text-white-50 mb-0" style={{ fontSize: '1.1rem' }}>
                                    From launching new initiatives to celebrating community achievements, follow our campaign updates to see how ideas turn into action and how collective efforts can make a lasting difference.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ================= NEW: STAY IN THE LOOP (Newsletter) ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 text-center">
                                <div 
                                    className="card border-0 rounded-4 shadow-lg p-4 p-md-5"
                                    style={{ background: '#ffffff', borderTop: '4px solid #fbbf24 !important' }}
                                >
                                    <div className="d-inline-flex align-items-center justify-content-center rounded-circle mx-auto mb-4" style={{ width: 64, height: 64, background: 'rgba(251,191,36,0.15)', color: '#d97706' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>

                                    <h3
                                        className="fw-bold mb-3"
                                        style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(1.8rem, 3vw, 2.25rem)', color: '#0f172a' }}
                                    >
                                        Never Miss an Update
                                    </h3>
                                    <p className="mb-4 mx-auto" style={{ color: '#4b5563', fontSize: '1.05rem', maxWidth: '500px' }}>
                                        Join our newsletter to receive the latest campaign news, event invitations, and impact stories directly in your inbox.
                                    </p>

                                    <form className="d-flex flex-column flex-sm-row gap-2 mx-auto" style={{ maxWidth: '500px' }}>
                                        <input 
                                            type="email" 
                                            className="form-control rounded-pill px-4 py-3" 
                                            placeholder="Enter your email address" 
                                            style={{ border: '1px solid #e2e8f0', background: '#f8fafc' }}
                                            required
                                        />
                                        <button 
                                            type="submit" 
                                            className="btn fw-bold rounded-pill px-4 py-3 text-nowrap"
                                            style={{ background: '#1e293b', color: '#ffffff' }}
                                        >
                                            Subscribe
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>
            <FundraisingFooter />
        </>
    );
};

export default CampaignUpdates;